import TrainFullness from './train-fullness';

export default TrainFullness;